import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import store from "./app/store"
import { I18nextProvider } from "react-i18next";
import i18n from './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root'));
root.render(
  // eslint-disable-next-line no-undef
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <App />
    </Provider>
  </I18nextProvider>
);


